<template>
  <div class="goods-form-wrapper" @keypress.esc="cancel">
    <div class="header-sidebar mb-4" slot="header">
      <h4 class="pull-left">{{ $t(`${section.toLowerCase()}.${mode}`) }}</h4>
      <b-button
        class="pull-right close-btn"
        @click="cancelAndClearInventory"
        type="button"
        variant="link"
      >
        <i class="fa fa-close"></i>
      </b-button>
      <div class="clearfix"></div>
      <hr />
    </div>
    <b-form>
      <b-row>
        <b-col cols="6">
          <b-form-group
            breakpoint="lg"
            label-size="sm"
            label-cols="4"
            label-for="regNumber"
            label-class="ml-1"
            @focus="$event.target.select()"
            class="required"
          >
            <template slot="label">
              {{ $t('incomes.name') }}
              <span class="text-danger">*</span>
            </template>
            <b-form-input
              :required="true"
              size="sm"
              id="regNumber"
              class="ml-1"
              v-validate="validators.regNumber"
              name="regNumber"
              v-model="formtItem.regNumber"
              :placeholder="$t('incomes.name')"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            breakpoint="lg"
            label-size="sm"
            label-cols="4"
            label-for="refName"
            class="required ml-1"
            size="sm"
          >
            <template slot="label">
              {{ $t('incomes.create.from-warehouse')}}
              <span class="text-danger">*</span>
            </template>
            <b-form-select
              size="sm"
              name="fromDepartment"
              v-model="formtItem.departmentId"
              v-validate="validators.fromDepartment"
            >
              <option
                v-for="(selectOption, indexOpt) in departments"
                :key="indexOpt"
                :value="selectOption.value"
                :disabled="selectOption.value === formtItem.toDepartmentId"
              >{{ selectOption.text }}</option>
              <template slot="first">
                <option :value="null" disabled>-- {{ $t('incomes.create.warehouse') }} --</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="form-group">
        <!-- REGISTER DATE -->
        <b-col cols="2">
          <p class="mb-0 mt-1">
            {{ $t('incomes.create.reg-date') }}
            <span class="text-danger">*</span>
          </p>
        </b-col>
        <b-col cols="4">
          <date-picker
            v-model="formtItem.regDate"
            v-validate="validators.regDate"
            name="regDate"
            lang="ru"
            :placeholder="$t('incomes.create.reg-date')"
            valueType="format"
            v-bind:class="{'is-invalid': !checkField('regDate')}"
            format="DD-MM-YYYY"
          ></date-picker>
        </b-col>
        <!-- EXPIRE DATE -->
        <b-col cols="2">
          <p class="mb-0 mt-1">
            {{ $t('booking.book-till-date') }}
            <span class="text-danger">*</span>
          </p>
        </b-col>
        <b-col cols="4">
          <date-picker
            v-model="formtItem.expireDate"
            v-validate="validators.expireDate"
            name="expireDate"
            :disabled-date="notBeforeRegDate"
            :disabled="!formtItem.regDate"
            lang="ru"
            :placeholder="$t('booking.book-till-date')"
            valueType="format"
            v-bind:class="{'is-invalid': !checkField('expireDate')}"
            format="DD-MM-YYYY"
          ></date-picker>
        </b-col>
      </b-row>

      <contr-agent-select
        :label="$t('incomes.create.counteragent')"
        :options="dropDowns.counterparties.items"
        v-model="formtItem.contragentId"
        @reload="fetchList"
        @lock="$emit('lock', true)"
      ></contr-agent-select>
      <br />
      <!-- IF MODE IS CREATE -->
      <booking-create-items
        :document-id="formtItem.id"
        :section="section"
        :items="formtItem.bookingItemDtos"
        @success="addItem"
        @successExcel="successExcel"
        @cancelExcel="cancelExcel"
        @changeRowVariant="changeRowVariant"
        :allTotalCount="allTotalCount"
        :incomeTotal="incomeTotal"
        :priceTotal="priceTotal"
        :department="departmentId"
        :toDepartmentId="formtItem.toDepartmentId"
        :depSaleType="fromDepartmentForCurrency.saleType"
        :currency-rate="currencyRate"
        :depCurrencyName="depCurrencyName"
        :incomeCurrency="incomeCurrency"
        :depsSelected="depsSelected"
      ></booking-create-items>

      <booking-items-list
        v-if="showItems"
        :items="formtItem.bookingItemDtos"
        @remove="removeItem"
        :mode="mode"
        :section="section"
        :depCurrencyName="depCurrencyName"
        :depSaleType="isBooking ? fromDepartmentForCurrency.saleType : toDepartmentForCurrency.saleType"
      ></booking-items-list>
      <div class="text-center mb-3" v-if="!showItems">
        <b-spinner size="sm" variant="primary"></b-spinner>
      </div>
      <b-row>
        <b-col cols="3"></b-col>
        <b-col cols="9">
          <b-form-group
            breakpoint="lg"
            label-size="sm"
            label-cols="2"
            :label="$t('comment')"
            label-for="refName"
            class="required"
          >
            <b-form-textarea v-model="formtItem.comment" :placeholder="$t('comment')"></b-form-textarea>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
    <div class="modal-actions">
      <b-row class="align-items-center">
        <b-col cols="6" class="mb-3 mb-xl-0">
          <b-row>
            <b-col cols="3">
              <b-button
                block
                size="sm"
                type="button"
                @click="cancelAndClearInventory"
                variant="outline-danger"
              >
                {{
                $t('cancel') }}
              </b-button>
            </b-col>
            <!-- SUSPEND QILISH PEREMESHENIYA UCHUN VAQTINCHA YOPILDI ABDUQODIR AYTTI 02.10.2019 -->
            <b-col cols="3">
              <b-button
                block
                :disabled="false"
                type="button"
                size="sm"
                class="btn btn-warning"
                @click="storeSusPend(true)"
                variant="primary"
              >{{ $t('save')}}</b-button>
            </b-col>
            <b-col cols="6">
              <b-button
                block
                :disabled="false"
                type="button"
                class="btn btn-success"
                size="sm"
                @click="store(true)"
                variant="primary"
              >{{ $t('warehouse.document.saveAndFinish') }}</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <b-modal
      v-model="depWarning"
      hide-title="true"
      ref="depWarningModal"
      @ok="depWarningOk"
      @cancel="depWarningCancel"
      ok-title="Да"
      cancel-title="Отмена"
    >
      <h5>Вы изменили отдел, в этом случае удаляется все добавленные товары. Продолжать?</h5>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";
import ContrAgentSelect from "../../../references/blocks/ContrAgentSelect";
import ContrAgentService from "../../../../services/contragent.service";
import UsersService from "../../../../services/users.sevice";
import WhDocument from "../../../../services/wh-document.service";
import Multiselect from "vue-multiselect";
import BookingItemsList from "./BookingItemsList";
import Employees from "../mixins/Employee";
import MaskedInput from "vue-masked-input";
import BookingCreateItems from "./BookingCreateItems";
import CurrencyService from "../../../../services/currency.service";
import { mapGetters, mapState, mapActions } from "vuex";
import { validators } from "../mixins/validators";

export default {
  name: "BookingCreateForm",

  mixins: [Employees, validators],

  components: {
    BookingCreateItems,
    ContrAgentSelect,
    MaskedInput,
    Multiselect,
    SelectOrCreate: () => import("../../../components/SelectOrCreate"),
    BookingItemsList
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    section: {
      type: String,
      default: "BOOKING"
    },
    editItem: {
      type: Object,
      default: null
    }
  },

  data: function() {
    return {
      incomeCurrencyId: null,
      item: {
        id: null,
        comment: "",
        status: "DRAFT",
        departmentId: null,
        departmentName: "",
        contragentId: null,
        contragentName: "",
        regNumber: "",
        regDate: "",
        expireDate: "",
        bookingItemDtos: []
      },
      depWarning: false,
      toDepartmentForCurrency: {
        currencyName: ""
      },
      fromDepartmentForCurrency: {
        currencyName: "",
        saleType: "WHOLE"
      },
      toggleCurrencyInputs: false,
      toggleCounter: 0,
      oldFromDepId: null,
      depCurrencyName: "",
      allTotalCount: 0,
      x: false,
      incomeTotal: 0,
      priceTotal: 0,
      dropDowns: {
        counterparties: {
          items: [],
          value: null
        },
        department: {
          items: [],
          value: null
        },
        transferPermittedDepartments: [],
        product: {
          items: [],
          value: null,
          loading: false,
          search: {
            page: 1,
            limit: 10,
            attributes: [
              {
                field: "name",
                value: "",
                option: "CONTAINS"
              }
            ]
          }
        },
        units: {
          items: [],
          value: null
        },
        provider: {
          items: [],
          value: null
        },
        employees: {
          from: null,
          to: null,
          responsible: null,
          responsible2: null,
          initiator: null
        }
      },
      currencyRate: -1,
      showItems: true,
      foundIndexOfFromDep: -1
    };
  },

  methods: {
    ...mapActions("references", ["getReferenceChildren"]),
    ...mapActions("warehouse", [
      "clearInventoryList",
      "getListByProductsNotKirim",
      "addRowVariantToXlsItems",
      "resetExcelData"
    ]),
    ...mapActions("booking", [
      "createBookingDoc",
      "saveBookingDoc",
      "suspendBookingDoc"
    ]),
    calculateTotalsForEdit() {
      this.allTotalCount = 0;
      this.incomeTotal = 0;
      this.priceTotal = 0;
      if (this.formtItem.bookingItemDtos) {
        this.formtItem.bookingItemDtos.forEach(item => {
          this.incomeTotal += item.incomingPriceUsd
            ? item.incomingPriceUsd * item.count
            : 0;
          this.priceTotal +=
            this.fromDepartmentForCurrency.saleType &&
            this.fromDepartmentForCurrency.saleType == "WHOLE"
              ? item.priceWholesale * item.count
              : item.priceUzs * item.count;
          this.allTotalCount += item.count;
        });
      }
    },
    notBeforeRegDate(date) {
      return date < this.formtItem.regDate;
    },
    depsSelected() {
      if (this.isBooking) {
        if (this.formtItem.departmentId && this.formtItem.toDepartmentId) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    depWarningOk() {
      this.depWarning = false;
      this.$refs.depWarningModal.hide();
      this.formtItem.bookingItemDtos.forEach((item, index) => {
        let foundIndex = this.formtItem.bookingItemDtos.findIndex(el => {
          return (el.id = item.id);
        });
        let newDepId = this.formtItem.departmentId;
        this.formtItem.departmentId = this.oldFromDepId;
        WhDocument.removeItem(this.formtItem).then(() => {
          this.formtItem.bookingItemDtos.splice(foundIndex, 1);
          this.formtItem.departmentId = newDepId;
        });
      });
    },
    depWarningCancel() {
      this.formtItem.departmentId = this.oldFromDepId;
      this.depWarning = false;
      this.$refs.depWarningModal.hide();
    },
    async cancel() {
      this.$store.commit("warehouse/setWhDocDisabled", false);
      this.$emit("close", true);
    },
    async cancelAndClearInventory() {
      this.$store.commit("warehouse/setWhDocDisabled", false);
      this.$emit("close", true);
    },

    /**
     *
     */
    async fetchList() {
      await ContrAgentService.search({
        page: 1,
        limit: 700
      }).then(response => {
        this.dropDowns.counterparties.items = response.data.items;
      });
    },

    /**
     *
     */
    async fetchPermissions() {
      if (this.$can("get", "permitted departments")) {
        await UsersService.getPermittedDepartments().then(response => {
          this.dropDowns.department.items = response.data.permittedDepartments;
          this.dropDowns.transferPermittedDepartments =
            response.data.transferPermittedDepartments;
        });
      }
    },

    /**
     * Store Warehouse document
     */
    storeSusPend(update = false) {
      if (!update) {
      } else {
        if (!this.formtItem.contragentId) {
          this.$vs.notify({
            title: "Пожалуйста выберите контрагента",
            color: "warning",
            icon: "close",
            position: "top-right"
          });
          return 0;
        }
        let vm = this;
        this.$validator
          .validate()
          .then(async function(valid) {
            if (valid && vm.formtItem.bookingItemDtos.length > 0) {
              let countErrorIndex = vm.formtItem.bookingItemDtos.findIndex(
                el => {
                  return el.count <= 0;
                }
              );
              if (countErrorIndex > -1) {
                vm.$vs.notify({
                  title: "Количество",
                  text: "Проверьте количество товаров!",
                  color: "warning",
                  icon: "close",
                  position: "top-right"
                });
                vm.$store.commit("warehouse/setWhDocDisabled", false);
                return 0;
              }
              if (vm.isBooking) {
                // if (vm.formtItem.toDepartmentId) {
                let countErrorArray = [];
                vm.formtItem.bookingItemDtos.forEach((item, index) => {
                  if (item.count > item.realBalance) {
                    vm.x = true;
                    Vue.set(item, "_rowVariant", "danger");
                    let tempArr = [
                      {
                        index: index,
                        item: item
                      }
                    ];
                    countErrorArray = [...countErrorArray, ...tempArr];
                  }
                });
                for (let i = 0; i < vm.formtItem.bookingItemDtos.length; i++) {
                  for (let j = 0; j < countErrorArray.length; j++) {
                    vm.formtItem.bookingItemDtos.splice(
                      countErrorArray[j].index,
                      1
                    );
                  }
                }
                for (let j = 0; j < countErrorArray.length; j++) {
                  vm.formtItem.bookingItemDtos.unshift(countErrorArray[j].item);
                }
                if (!vm.x) {
                  if (vm.formtItem.toCurrencyRate == "") {
                    vm.formtItem.toCurrencyRate = null;
                  } else if (vm.formtItem.fromCurrencyRate == "") {
                    vm.formtItem.fromCurrencyRate = null;
                  }
                  vm.formtItem.status = "SUSPENDED";
                  vm.formtItem.id = vm.currentDoc.id;
                  await vm.suspendBookingDoc(vm.formtItem);
                  if (vm.bookingError.boolean) {
                    vm.$vs.notify({
                      title: vm.$t("words.error"),
                      text: vm.bookingError.message,
                      color: "danger",
                      icon: "close",
                      position: "top-right"
                    });
                  } else {
                    vm.cancel();
                    vm.$emit("docSuspended", "forBooking");
                  }
                  // WhDocument.editTransferNew(vm.formtItem).then(response => {
                  // 	vm.formtItem.id = response.data.id;
                  // 	// vm.$emit('redirect', response.data.id);
                  // 	vm.cancel();
                  // 	vm.$emit('docSuspended', 'forTransfer');
                  // }).catch(error => {
                  // 	vm.$store.commit('warehouse/setWhDocDisabled', false);
                  // });
                  return;
                } else {
                  vm.x = false;
                  vm.$vs.notify({
                    title: vm.$t("words.error"),
                    text: "Проверьте количество товара!",
                    color: "danger",
                    icon: "close",
                    position: "top-right"
                  });
                  vm.$store.commit("warehouse/setWhDocDisabled", false);
                  return;
                }
                // } else {
                // 	vm.$vs.notify({
                // 		title: "Выберите Подразделение (Получатель)",
                // 		color: 'warning',
                // 		icon: 'close',
                // 		position: 'top-right'
                // 	});
                // 	vm.$store.commit('warehouse/setWhDocDisabled', false);
                // 	return 0;
                // }
              }
              if (vm.isKirim) {
                if (vm.notFoundItemsFromXls.length > 0) {
                  vm.$vs.notify({
                    time: 4500,
                    title: vm.$t("addFromExcelMsg"),
                    color: "warning",
                    icon: "close",
                    position: "top-right"
                  });
                  vm.$store.commit("warehouse/setWhDocDisabled", false);
                  return 0;
                } else {
                  vm.formtItem.documentStatus = "SUSPENDED";

                  WhDocument.editPrixodWithList(vm.formtItem)
                    .then(response => {
                      vm.$emit("docSuspended", "forIncome");
                      vm.cancel();
                      vm.$vs.notify({
                        text: "Документ успешно сохранен",
                        color: "success",
                        icon: "close",
                        position: "top-right"
                      });
                    })
                    .catch(error => {
                      vm.$vs.notify({
                        title: vm.$t("words.error"),
                        text: "Пожалуйста, проверьте все поле еще раз",
                        color: "danger",
                        icon: "close",
                        position: "top-right"
                      });
                      vm.$store.commit("warehouse/setWhDocDisabled", false);
                    });
                }
              } else {
                WhDocument.update(vm.formtItem)
                  .then(response => {
                    vm.formtItem.id = response.data.id;
                    vm.$emit("docSuspended", "forIncome");
                    vm.cancel();
                    vm.$vs.notify({
                      text: "Документ успешно сохранен",
                      color: "success",
                      icon: "close",
                      position: "top-right"
                    });
                  })
                  .catch(error => {
                    vm.$vs.notify({
                      title: vm.$t("words.error"),
                      text: "Пожалуйста, проверьте все поле еще раз",
                      color: "danger",
                      icon: "close",
                      position: "top-right"
                    });
                    vm.$store.commit("warehouse/setWhDocDisabled", false);
                  });
              }
            } else {
              Object.keys(vm.validationFields).some(key => {
                vm.validationFields[key].touched = true;
                vm.validationFields[key].dirty = true;
                vm.validationFields[key].changed = true;
              });

              vm.$vs.notify({
                title: vm.$t("words.error"),
                text: vm.$t("department.please-fill"),
                color: "danger",
                icon: "close",
                position: "top-right"
              });
              vm.$store.commit("warehouse/setWhDocDisabled", false);
            }
          })
          .catch(error => {
            this.$vs.notify({
              title: this.$t("words.error"),
              text: "Пожалуйста, проверьте все поле еще раз",
              color: "danger",
              icon: "close",
              position: "top-right"
            });
            this.$store.commit("warehouse/setWhDocDisabled", false);
          });
      }
    },

    async store(update = false) {
      this.$store.commit("warehouse/setWhDocDisabled", true);
      if (!update) {
        await this.createBookingDoc(this.formtItem);
        this.formtItem.regNumber = this.currentDoc.regNumber;
        this.formtItem.regDate = this.currentDoc.regDate;
      } else {
        let vm = this;
        if (!this.formtItem.contragentId) {
          this.$vs.notify({
            title: "Пожалуйста выберите контрагента",
            color: "warning",
            icon: "close",
            position: "top-right"
          });
          return 0;
        }
        this.$validator
          .validate()
          .then(async function(valid) {
            if (valid && vm.formtItem.bookingItemDtos.length > 0) {
              let countErrorIndex = vm.formtItem.bookingItemDtos.findIndex(
                el => {
                  return el.count <= 0;
                }
              );
              if (countErrorIndex > -1) {
                vm.$vs.notify({
                  title: "Количество",
                  text: "Проверьте количество товаров!",
                  color: "warning",
                  icon: "close",
                  position: "top-right"
                });
                vm.$store.commit("warehouse/setWhDocDisabled", false);
                return 0;
              }

              if (vm.isBooking) {
                // if (this.formtItem.toDepartmentId) {
                let countErrorArray = [];
                vm.formtItem.bookingItemDtos.forEach((item, index) => {
                  if (item.count > item.realBalance) {
                    vm.x = true;
                    Vue.set(item, "_rowVariant", "danger");
                    let tempArr = [
                      {
                        index: index,
                        item: item
                      }
                    ];
                    countErrorArray = [...countErrorArray, ...tempArr];
                  }
                });
                for (let i = 0; i < vm.formtItem.bookingItemDtos.length; i++) {
                  for (let k = 0; k < countErrorArray.length; k++) {
                    vm.formtItem.bookingItemDtos.splice(
                      countErrorArray[k].index,
                      1
                    );
                  }
                }
                for (let j = 0; j < countErrorArray.length; j++) {
                  vm.formtItem.bookingItemDtos.unshift(countErrorArray[j].item);
                }
                if (!vm.x) {
                  vm.formtItem.status = "READY";
                  vm.formtItem.id = vm.currentDoc.id;
                  await vm.saveBookingDoc(vm.formtItem);
                  if (vm.bookingError.boolean) {
                    vm.$vs.notify({
                      title: vm.$t("words.error"),
                      text: vm.bookingError.message,
                      color: "danger",
                      icon: "close",
                      position: "top-right"
                    });
                  } else {
                    vm.formtItem.id = vm.savedDoc.id;
                    vm.$emit("saved", vm.savedDoc.id);
                    vm.cancel();
                  }
                  return;
                } else {
                  vm.$vs.notify({
                    title: vm.$t("words.error"),
                    text: "Проверьте количество товара!",
                    color: "danger",
                    icon: "close",
                    position: "top-right"
                  });
                  vm.$store.commit("warehouse/setWhDocDisabled", false);
                  return;
                }
              }
            } else {
              Object.keys(this.validationFields).some(key => {
                this.validationFields[key].touched = true;
                this.validationFields[key].dirty = true;
                this.validationFields[key].changed = true;
              });

              this.$vs.notify({
                title: this.$t("words.error"),
                text: this.$t("department.please-fill"),
                color: "danger",
                icon: "close",
                position: "top-right"
              });
              this.$store.commit("warehouse/setWhDocDisabled", false);
            }
          })
          .catch(error => {
            this.$vs.notify({
              title: this.$t("words.error"),
              text: "Пожалуйста, проверьте все поле еще раз",
              color: "danger",
              icon: "close",
              position: "top-right"
            });
            this.$store.commit("warehouse/setWhDocDisabled", false);
          });
      }
    },

    setDocType() {
      if (this.isChiqim || this.isBooking) {
        this.formtItem.documentType = "AKT";
      }
      if (this.isOff) {
        this.formtItem.documentType = "PROTOKOL";
      }
    },

    /**
     *  Add Warehouse item
     */
    async addItem($event) {
      let findIndex = this.formtItem.bookingItemDtos.findIndex(el => {
        return el.itemId == $event.itemId;
      });

      if (findIndex >= 0) {
        if ($event.priceUzs || $event.incomingPriceUzs >= 0) {
          this.formtItem.bookingItemDtos[findIndex].count =
            parseInt(this.formtItem.bookingItemDtos[findIndex].count) +
            parseInt($event.count);
          this.formtItem.bookingItemDtos[
            findIndex
          ].incomingPriceUzs = $event.incomingPriceUzs
            ? $event.incomingPriceUzs
            : this.formtItem.bookingItemDtos[findIndex].incomingPriceUzs;
          this.formtItem.bookingItemDtos[findIndex].priceUzs = $event.priceUzs
            ? $event.priceUzs
            : this.formtItem.bookingItemDtos[findIndex].priceUzs;
          let temp = this.formtItem.bookingItemDtos[findIndex];
          if (temp._rowVariant) {
            if (temp._rowVariant == "primary") {
              temp._rowVariant = "warning";
            } else if (temp._rowVariant == "warning") {
              temp._rowVariant = "success";
            } else if (temp._rowVariant == "success") {
              temp._rowVariant = "warning";
            } else {
              temp._rowVariant = "warning";
            }
          } else {
            temp._rowVariant = "warning";
          }
          this.formtItem.bookingItemDtos.forEach((el, index) => {
            if (index !== findIndex) {
              delete el["_rowVariant"];
            }
          });
          this.formtItem.bookingItemDtos.splice(findIndex, 1);
          this.formtItem.bookingItemDtos.unshift(temp);
        } else {
          this.formtItem.bookingItemDtos[findIndex].count =
            parseInt(this.formtItem.bookingItemDtos[findIndex].count) +
            parseInt($event.count);
          let temp = this.formtItem.bookingItemDtos[findIndex];
          if (temp._rowVariant) {
            if (temp._rowVariant == "primary") {
              temp._rowVariant = "warning";
            } else if (temp._rowVariant == "warning") {
              temp._rowVariant = "success";
            } else if (temp._rowVariant == "success") {
              temp._rowVariant = "warning";
            }
          } else {
            temp._rowVariant = "warning";
          }
          this.formtItem.bookingItemDtos.forEach((el, index) => {
            if (index !== findIndex) {
              delete el["_rowVariant"];
            }
          });
          this.formtItem.bookingItemDtos.splice(findIndex, 1);
          this.formtItem.bookingItemDtos.unshift(temp);
        }
      } else {
        this.formtItem.bookingItemDtos.forEach(el => {
          delete el["_rowVariant"];
        });
        $event._rowVariant = "primary";
        $event.realBalance = this.balance;
        this.formtItem.bookingItemDtos.unshift($event);
      }
      this.$vs.notify({
        time: 1500,
        title: this.$t("add-product"),
        color: "success",
        icon: "close",
        position: "top-right"
      });
    },
    async successExcel() {
      await this.addRowVariantToXlsItems();
      await this.removeRowVariantFromWhItems();
      this.foundItemsFromXls.forEach(el => {
        let foundIndex = this.formtItem.bookingItemDtos.findIndex(
          x => x.itemId == el.itemId
        );
        if (foundIndex > -1) {
          this.formtItem.bookingItemDtos[foundIndex].count += el.count;
        } else {
          this.formtItem.bookingItemDtos.unshift(el);
        }
      });
      //this.formtItem.bookingItemDtos.unshift(...this.foundItemsFromXls);
    },
    async cancelExcel() {
      if (this.foundItemsFromXls.length > 0) {
        let vm = this;
        this.formtItem.bookingItemDtos = this.formtItem.bookingItemDtos.filter(
          function(el) {
            return vm.foundItemsFromXls.indexOf(el) < 0;
          }
        );
      }
      await this.resetExcelData();
    },
    removeRowVariantFromWhItems() {
      this.formtItem.bookingItemDtos.forEach((el, index) => {
        delete el["_rowVariant"];
      });
    },
    changeRowVariant(findIndex) {
      let temp = this.formtItem.bookingItemDtos[findIndex];
      temp._rowVariant = "danger";
      this.formtItem.bookingItemDtos.forEach((el, index) => {
        if (index !== findIndex) {
          delete el["_rowVariant"];
        }
      });
      this.formtItem.bookingItemDtos.splice(findIndex, 1);
      this.formtItem.bookingItemDtos.unshift(temp);
    },

    /**
     * Remove Warehouse item
     * @param $event
     */
    removeItem($event) {
      if (this.isBooking || this.isKirim) {
        this.formtItem.bookingItemDtos.splice($event, 1);
        return 1;
      }
    },

    setDropdowns() {
      this.dropDowns.counterparties.value = this.editItem.contragentId
        ? this.editItem.contragentId
        : null;
    },

    async loadWhItems(documentId) {
      await WhDocument.byDocument(documentId).then(response => {
        /**
         * Hozirgi Javascript qoidalari bilan Vue js Objectdagi har qanday o'zgarishni Reactive seza olmaydi,
         * shu sababdan Obyectga yangi property qo'shayotganda 'Vue.set' ishlatiladi (https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats).
         */
        response.data.forEach(el => {
          Vue.set(el, "wrappedItems", el.whWrappedItems);
        });
        Vue.set(this.formtItem, "whItems", response.data);
        this.showItems = true;
      });
    },

    fullName({ firstName, lastName, middleName }) {
      return `${firstName} ${lastName} ${middleName}`;
    }
  },

  // MOUNTED HOOK
  async mounted() {
    await this.fetchList();
    await this.fetchPermissions();
    if (this.mode === "create") {
      this.item.action = this.section;
      this.store();
    } else {
      // TRIGGER DEPARTMENT ID WATCHER
      let depId = this.formtItem.departmentId;
      this.formtItem.departmentId = null;
      this.formtItem.departmentId = depId;

      this.calculateTotalsForEdit();
    }
  },

  watch: {
    "dropDowns.department.items": {
      deep: true,
      handler(newValue) {
        if (this.mode !== "create" && newValue) {
          if (this.isKirim) {
            let fromDepTemp = this.dropDowns.department.items.find(item => {
              return item.id == this.editItem.toDepartmentId;
            });
            this.depCurrencyName = fromDepTemp
              ? fromDepTemp.currencyName
              : this.userDepCurrencyName;
          } else {
            let fromDepTemp = this.dropDowns.department.items.find(item => {
              return item.id == this.editItem.fromDepartmentId;
            });
            this.depCurrencyName = fromDepTemp
              ? fromDepTemp.currencyName
              : this.userDepCurrencyName;
          }
        }
      }
    },
    "dropDowns.employees.to": {
      handler(newValue) {
        if (!newValue) {
          return false;
        }
        this.formtItem.toEmployeeId = newValue.id;
      }
    },
    "dropDowns.employees.from": {
      handler(newValue) {
        if (!newValue) {
          return false;
        }
        this.formtItem.fromEmployeeId = newValue.id;
      }
    },
    "dropDowns.employees.responsible": {
      handler(newValue) {
        if (!newValue) {
          return false;
        }
        this.formtItem.responsible1Id = newValue.id;
      }
    },
    "dropDowns.employees.responsible2": {
      handler(newValue) {
        if (!newValue) {
          return false;
        }
        this.formtItem.responsible2Id = newValue.id;
      }
    },
    "dropDowns.employees.initiator": {
      handler(newValue) {
        if (!newValue) {
          return false;
        }
        this.formtItem.initiatorId = newValue.id;
      }
    },

    "formtItem.bookingItemDtos": {
      deep: true,
      handler(newVal) {
        this.allTotalCount = 0;
        this.incomeTotal = 0;
        this.priceTotal = 0;
        if (this.formtItem.bookingItemDtos) {
          this.formtItem.bookingItemDtos.forEach(item => {
            this.incomeTotal += item.incomingPriceUsd
              ? item.incomingPriceUsd * item.count
              : 0;
            this.priceTotal +=
              this.fromDepartmentForCurrency.saleType &&
              this.fromDepartmentForCurrency.saleType === "WHOLE"
                ? item.priceWholesale * item.count
                : item.priceUzs * item.count;
            this.allTotalCount += item.count;
          });
        }
      }
    },
    "formtItem.toDepartmentId": {
      deep: true,
      handler(newValue) {
        this.depsSelected();
        if (newValue) {
          this.toDepartmentForCurrency = this.dropDowns.transferPermittedDepartments.find(
            item => {
              return item.id == newValue;
            }
          );
        }
      }
    },
    "formtItem.departmentId": {
      deep: true,
      handler(newVal, oldVal) {
        this.depsSelected();
        if (newVal) {
          this.fromDepartmentForCurrency = this.dropDowns.department.items.find(
            item => {
              return item.id == newVal;
            }
          );
          Vue.set(
            this.fromDepartmentForCurrency,
            "",
            this.fromDepartmentForCurrency.saleType
          );
          Vue.set(
            this.fromDepartmentForCurrency,
            "saleType",
            this.fromDepartmentForCurrency.saleType
          );
          this.calculateTotalsForEdit();
          this.depCurrencyName = this.fromDepartmentForCurrency
            ? this.fromDepartmentForCurrency.currencyName
            : "";
        }
        this.depWarning = false;
        if (
          oldVal &&
          this.oldFromDepId &&
          newVal !== this.oldFromDepId &&
          this.formtItem.bookingItemDtos.length > 0
        ) {
          this.oldFromDepId = oldVal;
          this.depWarning = true;
          this.$refs.depWarningModal.show();
        }
      }
    },
    toggleCurrencyInputs: {
      handler(newVal) {
        this.toggleCounter++;
        if (newVal) {
          this.formtItem.fromCurrencyRate = 1;
          this.formtItem.toCurrencyRate = null;
        } else {
          this.formtItem.toCurrencyRate = 1;
          this.formtItem.fromCurrencyRate = null;
        }
      }
    }
  },

  computed: {
    ...mapState("references", ["refCurrencies"]),
    ...mapState(["userDepCurrencyName"]),
    ...mapGetters("warehouse", ["wTypes"]),
    ...mapState("warehouse", [
      "whDocSaveDisabled",
      "balance",
      "foundItemsFromXls",
      "notFoundItemsFromXls"
    ]),
    ...mapState("booking", ["currentDoc", "savedDoc", "bookingError"]),
    currencyDisabler() {
      if (this.toDepartmentForCurrency) {
        return !this.toDepartmentForCurrency.id;
      } else {
        return true;
      }
    },
    incomeCurrency() {
      let temp = {
        name: ""
      };
      if (this.formtItem.currencyId && this.refCurrencies.length > 0) {
        temp = this.refCurrencies.find(el => {
          return el.id == this.formtItem.currencyId;
        });
      }
      this.depCurrencyName = temp.name;
      return temp;
    },
    isIncomeCurrencyChanged() {
      if (this.toDepartmentForCurrency && this.formtItem.currencyId) {
        if (!this.toggleCurrencyInputs) {
          this.formtItem.fromCurrencyRate = 1;
          if (this.mode !== "edit" || this.toggleCounter > 0) {
            this.formtItem.toCurrencyRate = null;
          }
        } else {
          this.formtItem.fromCurrencyRate = null;
          this.formtItem.toCurrencyRate = 1;
        }
        if (
          this.toDepartmentForCurrency.currencyId &&
          this.formtItem.currencyId
        ) {
          return (
            this.toDepartmentForCurrency.currencyId !==
            this.formtItem.currencyId
          );
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isCurrenciesDifferent() {
      if (this.toDepartmentForCurrency) {
        if (
          this.toDepartmentForCurrency.id &&
          this.fromDepartmentForCurrency.id
        ) {
          if (!this.toggleCurrencyInputs) {
            this.formtItem.fromCurrencyRate = 1;
            this.formtItem.toCurrencyRate = null;
          } else {
            this.formtItem.fromCurrencyRate = null;
            this.formtItem.toCurrencyRate = 1;
          }
          if (
            this.toDepartmentForCurrency.currencyId &&
            this.fromDepartmentForCurrency.currencyId
          ) {
            return (
              this.toDepartmentForCurrency.currencyId !==
              this.fromDepartmentForCurrency.currencyId
            );
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    formtItem() {
      if (this.mode === "create") {
        return this.item;
      } else {
        return this.editItem;
      }
    },
    depWarningComputed() {
      return this.depWarning;
    },
    isChiqim() {
      return this.section === "CHIQIM";
    },
    isOff() {
      return this.section === "SPISAT";
    },
    isTransfer() {
      return this.section === "KOCHIRISH";
    },
    isKirim() {
      return this.section === "KIRIM";
    },
    isBooking() {
      return this.section === "BOOKING";
    },
    departments() {
      const departments = [];
      this.dropDowns.department.items.map(item => {
        if (this.wTypes.includes(item.typeName))
          departments.push({
            value: item.id,
            text: `${item.name} ${item.parentName ? "-" + item.parentName : ""}`
          });
      });
      if (this.formtItem.departmentId) {
        let customDepartments = {};
        customDepartments.fromDepartmentId = this.formtItem.departmentId;
        customDepartments.toDepartmentId = this.formtItem.toDepartmentId;
        customDepartments.section = this.section;

        this.$store.commit("warehouse/setFromDepartmentId", customDepartments);
        this.foundIndexOfFromDep = departments.findIndex(
          el => el.value == this.formtItem.departmentId
        );
      } else {
        this.foundIndexOfFromDep = -1;
      }
      return departments;
    },
    toDepartments() {
      const departments = [];
      this.dropDowns.transferPermittedDepartments.map(item => {
        if (this.wTypes.includes(item.typeName))
          departments.push({
            value: item.id,
            text: `${item.name} - ${item.parentName}`,
            saleType: item.saleType
          });
      });
      if (this.foundIndexOfFromDep !== -1) {
      }
      return departments;
    },

    departmentId() {
      let customDepartments = {};
      customDepartments.fromDepartmentId = this.formtItem.departmentId;
      customDepartments.toDepartmentId = this.formtItem.toDepartmentId;
      customDepartments.section = this.section;

      this.$store.commit("warehouse/setFromDepartmentId", customDepartments);
      return this.isKirim
        ? this.formtItem.toDepartmentId
        : this.formtItem.departmentId;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.fromCurrencyRateId + div {
  padding: 0 !important;
}
.mx-datepicker {
  padding-left: 0;
}
.is-invalid {
  input {
    border-color: red !important;
  }
}
</style>
